<form [formGroup]="driverLicenseForm">
  <h4 class="font-weight-semibold font-size-1-50">{{ driversLicenseConfig.header }}</h4>

  <div class="pad-top-16">
    <div class="font-9 pad-bottom-10">{{ driversLicenseConfig.driversHeader }}</div>
    <div class="radio-group">
      <ds-radio-group
        class="options"
        control="driver"
        [parentFormGroup]="driverLicenseForm"
        [options]="driverOptions"
        [selectedAnswer]="driverOptions[0]?.id"
      >
      </ds-radio-group>
    </div>
  </div>

  <ds-form-control-container [labelText]="driversLicenseConfig.state" [control]="state">
    <select
      id="stateInput"
      class="icon fill"
      formControlName="state"
      data-cy="requestChangeDriverLicenseStateSelect"
    >
      @for (state of states; track state) {
        <option [value]="state?.value">{{ state?.name }}</option>
      }</select
    ><span class="icon-chevron-down"></span>
    <ds-form-control-message [control]="state"></ds-form-control-message>
  </ds-form-control-container>
  <ds-form-control-container
    [labelText]="driversLicenseConfig.driverLicense"
    [control]="licenseNumber"
  >
    <input
      type="text"
      id="licenseNumber"
      class="fill"
      formControlName="licenseNumber"
      data-cy="licenseNumber"
    />
    <ds-form-control-message [control]="licenseNumber"></ds-form-control-message>
  </ds-form-control-container>
  <ds-form-control-container [labelText]="driversLicenseConfig.reason" [control]="reason">
    <textarea
      maxlength="850"
      id="reasonText"
      class="fill"
      formControlName="reason"
      rows="10"
      data-cy="requestChangeReasonInput"
      textCounter
      [maxCount]="850"
    ></textarea>
    <ds-form-control-message [control]="reason"></ds-form-control-message>
  </ds-form-control-container>

  <!-- Action Buttons -->
  <call-to-action
    [primaryButtonName]="driversLicenseConfig.submit"
    [tertiaryButtonName]="driversLicenseConfig.cancel"
    [capitalize]="true"
    [disablePrimaryButton]="!valid"
    (primaryEvent)="onSubmit()"
    (tertiaryEvent)="cancel()"
  >
  </call-to-action>
</form>
<ds-modal
  [id]="agentsModal"
  [closeOthers]="true"
  [showCloseButton]="false"
  [closeOnBackdropClick]="false"
>
  <div class="margin-bottom-20">
    <app-agent-selector
      [agents]="agents"
      primaryButtonName="Submit"
      secondaryButtonName="Cancel"
      (sendToAgent)="sendToAgent($event)"
      (cancel)="closeModal()"
    ></app-agent-selector>
  </div>
</ds-modal>
